module.exports = __webpack_public_path__ + "media/Bird2.3fafa56e.ogg";